export enum ArticleWorkflow {
    create = "create",
    edit = "edit",
}

export enum ArticleMachineStep {
    basicData = 1,
    description,
    summary,
}

export enum ArticleEquipmentStep {
    basicData = 1,
    features,
    description,
    summary,
}

// export enum ArticleStep {
//     requestDetails = 1,
//     customerDetails,
//     location,
//     configuration,
//     pricing,
//     shippingDetails,
//     summary,
// }
